import Employee from "./employee/employee_dashboard.store";
import Attendance from "./attendance/attendance_dashboard.store";

export default {
  modules: { Employee, Attendance },
};
